import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { IPadHistory } from '../models/ipadhistory-model'
@Injectable()
export class EnrollmentDataService {
    private messageDataSource = new BehaviorSubject('default message')
    data = this.messageDataSource.asObservable()

    private ElectionPeriodChangeSource = new BehaviorSubject('default message')
    elecPeriod = this.ElectionPeriodChangeSource.asObservable()

    constructor() {}

    sendData(data: string) {
        this.messageDataSource.next(data)
    }

    electionPeriodChanged(elecPeriod: string) {
        this.ElectionPeriodChangeSource.next(elecPeriod)
    }
}
@Injectable()
export class MemberIPadService {
    searchdata = {} as IPadHistory
    private messageDataSource = new BehaviorSubject(this.searchdata)
    data = this.messageDataSource.asObservable()

    filterdata = {} as IPadHistory
    private searchDataSource = new BehaviorSubject(this.filterdata)
    model = this.searchDataSource.asObservable()
    constructor() {}

    filterData(model: IPadHistory) {
        this.searchDataSource.next(model)
    }
}
